export const NotificationTypes = {
  NEW_REPORT_RECEIVED: 0,
  NEW_COMMENT_ON_REPORT: 1,
  NEW_DATUM_ON_COMPANY: 2,
  NEW_COMMENT_ON_COMPANY: 3,
  GROUP_RELATIONSHIP_UPDATE: 4,
  REPORT_RELATIONSHIP_UPDATE: 5,
}
